<template>
  <div class="page">
    <!-- <div class="topImg">
      <template v-if="detail.content_top.type == 1">
        <img :src="detail.content_top.url" />
      </template>
      <template v-else-if="detail.content_top.type == 2">
        <div v-html="detail.content_top.content">
          {{ detail.content_top.content }}
        </div>
      </template>
      <template v-else>
        <div class="topWz">{{ detail.content_top.content }}</div>
      </template>
    </div>-->
    <!-- <div
      class="topImg"
      :style="{
        width: isMobile ? '140%' : '',
        marginLeft: isMobile ? '-20%' : '',
      }"
    >
      <template v-if="detail.lower_level_content_top.type == 1">
        <img :src="detail.lower_level_content_top.url" />
      </template>
      <template v-else-if="detail.lower_level_content_top.type == 2">
        <div v-html="detail.lower_level_content_top.content">
          {{ detail.lower_level_content_top.content }}
        </div>
      </template>
      <template v-else>
        <div class="topWz">{{ detail.lower_level_content_top.content }}</div>
      </template>
    </div>-->

    <div class="centent">
      <el-button
        type="primary"
        style="width:100px;background:#e40001;border:1px solid #e40001;"
        v-loading="saveLoading"
        size="medium"
        @click="goBack()"
      >返回首页</el-button>
      <div class="top" style="display: flex;flex-wrap: wrap;">
        <div class="nav">
          <div>当前位置：</div>
          <el-breadcrumb separator-class="el-icon-arrow-right" style="cursor: pointer">
            <el-breadcrumb-item :to="'/?id=' + publicId">
              {{
              detail.title
              }}
            </el-breadcrumb-item>
            <!-- <el-breadcrumb-item>{{typeIdTtitle}}</el-breadcrumb-item> -->
          </el-breadcrumb>
        </div>
        <div style="flex: 1; margin-left: 20px;">
          <el-select v-model="typeId" placeholder="请选择" @change="handleChangeTwo">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <!-- <el-cascader v-model="typeIdTwo" placeholder="请选择" :options="typeList" v-loading="typeLoad" 	@change="handleChange" :props="typeProps"></el-cascader> -->
        </div>
      </div>
      <div class="cententForChilImgBox">
        <el-row :gutter="10">
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            :lg="6"
            :xl="6"
            v-for="(itemaa, indexaa) in detailTwo"
            :key="indexaa + 'aa'"
          >
            <div class="cententForChilImgBoxList" @click="goDetail(itemaa)">
              <div class="cententForChilImgBoxListImg">
                <img :src="itemaa.cover" />
                <!-- <div class="tjbox">
                  <img src="@/assets/tj.png" alt="" />
                </div>-->
                <div class="dz" style="display: flex;">
                  <i
                    v-if="itemaa.photo_number > 1"
                    style="display: flex;align-items: center;margin-right: 5px;"
                    class="el-icon-document-copy"
                  ></i>
                  <div class="dzTil">
                    {{ itemaa.title
                    }}{{ itemaa.name ? `(${itemaa.name})` : "" }}
                  </div>
                  <!-- <div
                    style="display: flex;"
                    v-if="itemaa.is_excellent !== 1"
                    @click.stop="goLike(itemaa)"
                  >
                    <div class="dzImg">
                      <img style="cursor: pointer;" v-if="itemaa.is_like" src="@/assets/ydz.png" />
                      <img style="cursor: pointer;" v-else src="@/assets/wdz1.png" />
                    </div>
                    <div class="dzNumber">{{ itemaa.like_num }}</div>
                  </div> -->
                  <!-- <div
                    style="display: flex;margin-left:10px;"
                    @click.stop="goVote(itemaa)"
                    v-if="itemaa.is_excellent !== 1 && detail.is_open_vote == 1"
                  >
                    <div class="dzImg">
                      <img style="cursor: pointer;" v-if="itemaa.is_vote" src="@/assets/ytp.png" />
                      <img style="cursor: pointer;" v-else src="@/assets/wtp1.png" />
                    </div>
                    <div class="dzNumber">{{ itemaa.vote_num || 0 }}</div>
                  </div> -->
                </div>
              </div>
              <!--<div class="cententForChilImgBoxListDz">
								<div class="cententForChilImgBoxListTil">
									{{itemaa.title}}{{itemaa.name?`(${itemaa.name})`:''}}
								</div>
								 <div @click.stop="goLike(itemaa)" style="display: flex;" v-if="itemaa.shadow_game_type.is_excellent!==1">
									<div class="cententForChilImgBoxListDzImg">
										<img style="cursor: pointer;" v-if="itemaa.is_like" src="@/assets/ydz.png" />
										<img style="cursor: pointer;" v-else src="@/assets/wdz.png" />
									</div>
									<div class="cententForChilImgBoxListDzNum">
										{{itemaa.like_num||0}}
									</div>
								</div> 

              </div>-->
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="!detailTwo || detailTwo.length < 1">
        <el-empty description="暂无数据"></el-empty>
      </div>
      <div class="pagination">
        <el-pagination
          v-if="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[16, 30, 50, 100]"
          :page-size="limit"
          :hide-on-single-page="false"
          layout="total, sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div
      class="topImg"
      :style="{
        width: isMobile ? '140%' : '',
        marginLeft: isMobile ? '-20%' : '',
      }"
    >
      <template v-if="detail.lower_level_content_bottom.type == 1">
        <img :src="detail.lower_level_content_bottom.url" />
      </template>
      <template v-else-if="detail.lower_level_content_bottom.type == 2">
        <!-- <img :src="detail.content_bottom.url" />
        <div class="topDw">{{detail.content_bottom.content}}</div>-->
        <div v-html="detail.lower_level_content_bottom.content"></div>
      </template>
      <template v-else>
        <div class="topWz">{{ detail.lower_level_content_bottom.content }}</div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  getShadowGameDetailAPI,
  shadow_game_album_dz_api,
  shadow_game_album_list_api,
  shadow_game_type_api,
  shadow_game_album_vote_api
} from "@/api/index.js";
import { getShadowGameRoute } from "@/utils/shadowGameRoute";
export default {
  components: {},
  data() {
    return {
      id: "",
      publicId: "",
      detail: {
        content_top: {},
        event_overview: {},
        content_bottom: {},
        lower_level_content_bottom: {},
        lower_level_content_top: {}
      },
      detailTwo: [],
      typeid: "",
      page: 1,
      limit: 16,
      total: 0,
      typeId: "",
      typeList: [],
      typeLoad: false,
      typeProps: {
        value: "id",
        label: "name"
      },
      typeIdTwo: [],
      typeIdTtitle: ""
    };
  },
  mounted() {
    const gameRoute = getShadowGameRoute(this.$route.query.id);
    this.publicId = gameRoute.publicId;
    this.id = gameRoute.gameId;
    this.typeId = Number(this.$route.query.pid);
    let typeid = this.$route.query.typeId;
    this.typeIdTwo = [Number(typeid), Number(this.typeId)];
    console.log(this.typeIdTwo);
    this.getDetail();
    this.getDetailType();
    this.getThreeType();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    removePreAndCodeTags(htmlString) {
      const regex = /<pre[^>]*>|<code[^>]*>|<\/pre>|<\/code>/gi;
      return htmlString.replace(regex, "");
    },
    replaceAngleBrackets(str) {
      return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    },
    handleChange(e) {
      console.log(e);
      this.typeId = e[0];
      this.getDetailType();
    },
    getThreeType() {
      let data = {
        shadow_game_id: this.id
      };
      this.typeLoad = true;
      shadow_game_type_api(data)
        .then(res => {
          console.log(res);
          this.typeLoad = false;
          let list = res.data.children;
          let title = "";
          let lista = [];
          list.map(v => {
            if (v.id == this.typeIdTwo[0]) {
              // title=v.name
              v.children.map(a => {
                if (a.id == this.typeIdTwo[1]) {
                  title = a.name;
                }
                lista.push(a);
              });
            } else {
              v.children.map(a => {
                lista.push(a);
              });
            }
          });
          this.$nextTick(function() {
            this.typeIdTtitle = title;
            this.typeList = lista;
            // this.typeList = res.data.children;
          });
        })
        .catch(err => {
          this.typeLoad = false;
          console.log(err);
        });
    },
    getDetail() {
      let data = {
        id: this.id
      };
      getShadowGameDetailAPI(data)
        .then(res => {
          console.log(res);
          this.detail = res.data;
          document.title = this.detail.title;

          if (this.detail.content_top.type) {
            this.detail.content_top.content = this.removePreAndCodeTags(
              this.detail.content_top.content
            );
            this.detail.content_top.content = this.replaceAngleBrackets(
              this.detail.content_top.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.content_top.content = this.detail.content_top.content.replace(
              regex,
              `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
            );
          }
          if (this.detail.event_overview.type) {
            this.detail.event_overview.content = this.removePreAndCodeTags(
              this.detail.event_overview.content
            );
            this.detail.event_overview.content = this.replaceAngleBrackets(
              this.detail.event_overview.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.event_overview.content = this.detail.event_overview.content.replace(
              regex,
              `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
            );
          }
          if (this.detail.content_bottom.type) {
            this.detail.content_bottom.content = this.removePreAndCodeTags(
              this.detail.content_bottom.content
            );
            this.detail.content_bottom.content = this.replaceAngleBrackets(
              this.detail.content_bottom.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.content_bottom.content = this.detail.content_bottom.content.replace(
              regex,
              `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
            );
          }
          if (this.detail.lower_level_content_top.type) {
            this.detail.lower_level_content_top.content = this.removePreAndCodeTags(
              this.detail.lower_level_content_top.content
            );
            this.detail.lower_level_content_top.content = this.replaceAngleBrackets(
              this.detail.lower_level_content_top.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.lower_level_content_top.content = this.detail.lower_level_content_top.content.replace(
              regex,
              `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
            );
          }
          if (this.detail.lower_level_content_bottom.type) {
            this.detail.lower_level_content_bottom.content = this.removePreAndCodeTags(
              this.detail.lower_level_content_bottom.content
            );
            this.detail.lower_level_content_bottom.content = this.replaceAngleBrackets(
              this.detail.lower_level_content_bottom.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.lower_level_content_bottom.content = this.detail.lower_level_content_bottom.content.replace(
              regex,
              `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDetailType() {
      let data = {
        shadow_game_type_id: this.typeId,
        page: this.page,
        limit: this.limit
      };
      const loading = this.$loading({
        lock: true
      });
      shadow_game_album_list_api(data)
        .then(res => {
          console.log(res);
          this.detailTwo = res.data;
          console.log("--------------- this.detailTwo", this.detailTwo);
          this.total = res.pagination.total;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    goLike(e) {
      let data = {
        shadow_game_album_id: e.id
      };
      const loading = this.$loading({
        lock: true
      });
      shadow_game_album_dz_api(data)
        .then(res => {
          console.log(res);
          e.is_like = !e.is_like;
          if (e.is_like) {
            e.like_num++;
          } else {
            e.like_num--;
          }
          this.$message.success(res.msg);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    goMore(e) {
      this.$router.push({ path: "/list", query: { id: this.publicId, pid: e.id } });
    },
    goDetail(e) {
      this.$router.push("/detail?id=" + e.id);
    },
    // 切换页码
    handleSizeChange(e) {
      this.limit = e;
      this.page = 1;
      this.getDetailType();
    },
    // 切换页
    handleCurrentChange(e) {
      this.page = e;
      this.getDetailType();
    },
    handleChangeTwo(e) {
      this.getDetailType();
    },
    goVote(e) {
      let data = {
        shadow_game_album_id: e.id
      };
      const loading = this.$loading({
        lock: true
      });
      shadow_game_album_vote_api(data)
        .then(res => {
          if (res.code == 200) {
            e.is_vote = true;
            e.vote_num++;
          }
          // e.is_vote = !e.is_vote;
          // if (e.is_vote) {
          //   e.vote_num++;
          // } else {
          //   e.vote_num--;
          // }
          this.$message.success(res.msg);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style></style>
<style scoped lang="scss">
.page {
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.el-row {
  max-width: 100%;
  box-sizing: border-box;
  margin-left: 0 !important;
  margin-right: 0 !important;

  &:last-child {
    margin-bottom: 0;
  }
}

.topImg {
  width: 100%;
  position: relative;

  img {
    width: 100%;
    display: block;
    margin: 0;
    padding: 0;
  }

  .topDw {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }

  .topWz {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin: 20px 0;
  }
}

.centent {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 20px;
  box-sizing: border-box;
  .cententForChilImgBox {
    margin-top: 20px;

    .cententForChilImgBoxList {
      box-shadow: 0px 4px 20px 0px rgba(115, 115, 115, 0.3);
      border-radius: 8px;
      width: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      // padding-bottom: 15px;
      margin-bottom: 15px;

      .cententForChilImgBoxListImg {
        width: 100%;
        position: relative;
        height: 150px;
        > img {
          border-radius: 8px;
          width: 100%;
          height: 150px;
          object-fit: cover;
        }
      }

      .cententForChilImgBoxListDz {
        display: flex;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        margin-top: 15px;

        .cententForChilImgBoxListTil {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }

        .cententForChilImgBoxListDzImg {
          margin-left: 10px;
          img {
            width: 20px;
            height: 20px;
          }
        }

        .cententForChilImgBoxListDzNum {
          // font-size: 14px;
          margin-left: 10px;
        }
      }
    }
  }
}
.top {
  margin: 16px 0;
  .nav {
    display: flex;
    font-size: 14px;
    align-items: center;
    line-height: 1;
    margin: 0 auto;

    ::v-deep {
      .el-breadcrumb {
        font-size: 14px;
      }
    }
  }
}
.pagination {
  text-align: center;
  margin: 20px 0;
}
.tjbox {
  position: absolute;
  top: 2%;
  right: 2%;
  img {
    width: 30px;
    height: 30px;
  }
}
.dz {
  position: absolute;
  bottom: 0px;
  right: 0px;
  // height: 30px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  // justify-content: end;
  color: #fff;
  border-radius: 0 0 8px 8px;
  .dzTil {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #fff;
  }
  .dzImg {
    display: flex;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .dzNumber {
    margin-left: 10px;
  }
}
</style>
